import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EmailContentComponent} from './email-content/email-content.component';
import {SendTermsComponent} from './send-terms/send-terms.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {IssuePageComponent} from './issue-page/issue-page.component';
import {ExpiredPageComponent} from './expired-page/expired-page.component';

const routes: Routes = [
  {path: 'terms/:token', component: SendTermsComponent},
  {path: 'email-content/:token', component: EmailContentComponent},
  {path: 'issue', component: IssuePageComponent},
  {path: 'expired', component: ExpiredPageComponent},
  // {path: 'pec-mailbox/:token', component: PecMailboxComponent},
  {path: '**', component: PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
